import { DepthOfField, EffectComposer } from '@react-three/postprocessing'

export default function Effects()
{

    return < EffectComposer disableNormalPass>
        {/* <DepthOfField
            focusDistance={0.01}
            focusLength={0.2}
            bokehScale={1}
        /> */}
    </EffectComposer>

}